import { Avatar, Button, Dropdown, List, Menu, message, Radio, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/authContext';
import { CheckCircle, LogOut, Plus, User2 } from 'lucide-react';



function ProfileMenu() {
    const { logout } = useAuth()
    const navigate = useNavigate()

    const handleLogout = () => {
        logout()
    }


    const menu = (
        <Menu
            className="custom-profile-dropdowns"
            items={[
                
                {
                    key: '1',
                    label: (
                        <p  onClick={handleLogout}  > <LogOut size={16} /> Logout</p>
                    ),
                },
            ]}
        />
    );


    return (

        <div >
            <Space direction="vertical">
                <Dropdown overlay={menu} placement="bottomRight" trigger={['click']}>
                    <Space style={{ cursor: "pointer" }}>
                        <h3> Welcome, Super Admin  </h3>
                        <Avatar size={36} icon={<User2 size={20} />} />
                    </Space>
                </Dropdown>
            </Space>
        </div>
    )
}



export default ProfileMenu